import React from 'react'
import './style.css'
import ReviewHeader from '../ReviewHeader'
import styled from 'styled-components';

const ReviewContent = () => {
  return (
    <div className='reviewContent'>
      <ReviewHeader />
      <Content>

      </Content>

    </div>
  )
}

export default ReviewContent

const Content = styled.div`



`
